<template>
  <v-container
    lcd
    fluid
    grid-list-xl
    pt-0
  >
    <v-layout wrap>
      <v-flex
        xs12
      >
        <material-card
          :class="{'card-shrink-active': shrink_1, 'card-shrink-70': shrink_1}"
          title="TPOHM Analyzer"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <v-icon
            :class="{'card-shrink-active-icon' : shrink_1}"
            @click="shrink_1=!shrink_1"
          >mdi-apple-keyboard-control</v-icon>
          <v-form>
            <v-container
              py-0
              class="mw-100">
              <v-layout wrap>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryFactory"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryFactoryMenu"
                    label="Factory"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summaryYear"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryYearMenu"
                    label="Year(option)"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summarySeries"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summarySeriesMenu"
                    label="Series(option)"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg2>
                  <v-autocomplete
                    v-model="summaryProject"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryProjectMenu"
                    label="Project"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  sm6
                  lg1>
                  <v-autocomplete
                    v-model="summaryOHMType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryOHMTypeMenu"
                    label="Type"
                    class="v-text-field__slot"
                    persistent-hint
                    outlined
                  />
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  d-flex
                  align-items-center
                  xs12
                  lg4>
                  <p class="m-0">Time Interval</p>
                  <v-menu
                    v-model="summaryRangeStartDateMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryRangeStartDate"
                      label=""
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryRangeStartDate"
                      :min="startdate"
                      :max="new Date() | date-format"
                       :events="highlightedDates"
                      :event-color="getEventColor"
                      :color="theme==='dark'?'danger':'general'"
                      type="date"
                      no-title
                      scrollable
                      actions/>
                  </v-menu>
                  <!-- <v-menu
                    v-model="startTimeMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    style="max-width: 100px;margin-left: 10px;"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="startTime"
                      label=""
                      prepend-icon=""
                    />
                    <v-time-picker
                      v-model="startTime"
                      :color="theme==='dark'?'error':'general'"
                      :allowed-minutes="m => m % 30 === 0"
                      format="24hr"
                      type="time"/>
                  </v-menu> -->
                  <p class="m-0 text-center px-3">到</p>
                  <v-menu
                    v-model="summaryRangeEndDateMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryRangeEndDate"
                      label=""
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryRangeEndDate"
                      :min="summaryRangeStartDate"
                      :max="new Date() | date-format"
                       :events="highlightedEndDates"
                      :event-color="getEndEventColor"
                      :color="theme==='dark'?'danger':'general'"
                      type="date"
                      no-title
                      scrollable
                      actions/>
                  </v-menu>
                  <!-- <v-menu
                    v-model="endTimeMenu"
                    :close-on-content-click="false"
                    :nudge-left="40"
                    lazy
                    transition="scale-transition"
                    style="max-width: 100px;margin-left: 10px;"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="endTime"
                      label=""
                      prepend-icon=""
                    />
                    <v-time-picker
                      v-model="endTime"
                      :color="theme==='dark'?'error':'general'"
                      :allowed-minutes="m => m % 30 === 0"
                      format="24hr"
                      type="time"/>
                  </v-menu> -->
                </v-flex>
                <v-flex
                  flex-small
                  mt-3
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center
                >
                  <v-btn
                    v-if="shrink_1"
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSubmit()"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
                <v-flex
                  flex-small
                  border-primary
                  xs12
                  lg12
                  style="border-top: 2px dashed;"/>
                <v-flex
                  flex-small
                  xs12
                  sm6
                  lg3>
                  <v-text-field
                    v-model="summary.i1Sn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="i1 SN"/>
                </v-flex>
                     <v-flex
                  flex-small
                  xs12
                  sm6
                  lg8>
                </v-flex>
                <!-- <v-flex
                  flex-small
                  xs12
                  sm6
                  lg1>
                  <v-text-field
                    v-model="prodid"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    label="PROD ID"/>
                </v-flex> -->
                <!-- <v-flex
                  flex-small
                  xs12
                  sm6
                  lg2>
                  <v-datetime-picker
                    v-model="datetime"
                    :text-field-props="textFieldProps"
                    :date-picker-props="dateProps"
                    :time-picker-props="timeProps"
                    time-format="HH:mm:ss"
                    class="datetime"
                  />
                </v-flex> -->
                <v-flex
                  flex-small
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="general"
                    @click="doSubmit()"
                  >
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
                <v-flex
                  xs12
                  lg12
                />
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex
        v-if="submit"
        xs12
        sm6
        lg3>
        <material-stats-card
          v-model="passAmount"
          class="v-offset-none text-success"
          style="margin:0 !important;"
          color="purple"
          icon="mdi-folder-open"
          title="Test Pass"/>
      </v-flex>
      <v-flex
        v-if="submit"
        xs12
        sm6
        lg3>
        <material-stats-card
          v-model="failAmount"
          class="v-offset-none text-danger"
          style="margin:0 !important;"
          color="indigo"
          icon="mdi-calendar"
          title="Test Fail"/>
      </v-flex>
      <v-flex
        v-if="submit"
        xs12
        sm6
        lg3>
        <material-stats-card
          v-model="totalTestInputs"
          class="v-offset-none text-info"
          style="margin:0 !important;"
          color="light-blue"
          icon="mdi-factory"
          title="Test Total"/>
      </v-flex>
      <v-flex
        v-if="submit"
        xs12
        sm6
        lg3>
        <material-stats-card
          :value="(totalTestInputs>0?((Number(passAmount)/Number(totalTestInputs) * 100).toFixed(1)):0) + '%'"
          :class="(Number(passAmount)/Number(totalTestInputs)<0.8)?'red':'green'"
          :color="(Number(passAmount)/Number(totalTestInputs)<0.8)?'pink':'light-green'"
          :icon="(Number(passAmount)/Number(totalTestInputs)<0.8)?'mdi-alert':'mdi-check'"
          class="title-color"
          style="margin:0 !important;"
          title="Test Pass Rate"/>
      </v-flex>
      <v-flex
        v-if="submit"
        flex_width_auto
        xs12>
        <material-card
          id="checkTable"
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          title="查詢結果列表"
          color="deep-orange"
          class="card-mix card-padding">
          <v-select
            v-model="pagination.current.rowsPerPage"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="rowsAmount"
            class="mix-list v-text-field__slot d-inline-block float-right ml-5"
            style="width: 90px;"
            persistent-hint
            outlined
          />
          <router-link
            v-if="responseData.length>0"
            :to="'/TPOHM/TPImpedance/ShowErrorpieChart'"
            class="mix-btn p-0"
            style="right: 50.5rem;"
            target="_blank">
            <v-btn class="black text-light primary mx-0 px-2">
              <v-icon class="float-left mr-1">mdi-chart-scatterplot-hexbin</v-icon>ErrorCode
            </v-btn>
          </router-link>
          <v-btn
            v-if="responseData.length>0"
            class="mix-btn black text-light"
            style="right: 8rem;"
            @click="downloadCSV()">
            <v-icon class="float-left mr-1">mdi-download</v-icon>下載Excel
          </v-btn>
          <v-autocomplete
            id="checkTableInput"
            v-model="checkTableShowList"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items=checkTableInputDefine
            label="選擇欄位"
            class="v-text-field__slot row-btn-175 pt-0 mt-3"
            color="white"
            multitude
            chips
            persistent-hint
            multiple
            outlined
          />
          <v-btn
            class="red text-light float-right mr-0 mt-4"
            @click="checkTableShowListClear()"
          >
            清除
          </v-btn>
          <v-btn
            class="blue text-light float-right mt-4"
            @click="checkTableShowListAll()"
          >
            全選
          </v-btn>
        </material-card>
        <material-card
          :style="'max-width: calc(100vw - '+(Number(shrink)+32)+'px);'"
          class="d-table-t0 no-data-left">
          <!-- <v-select
            v-model="pagination.rowsPerPage"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="rowsAmount"
            class="v-text-field__slot d-inline-block float-right ml-5"
            style="width: 90px;"
            persistent-hint
            outlined
          /> -->
          <v-data-table
            :headers="responseHeaders"
            :items="responseData"
            :pagination.sync="pagination.current"
            :rows-per-page-items="rowsAmount"
            :class="{ 'showList': checkTableShowList.length>0}"
            class="freeze-title height-row-3"
            multi-sort
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-general text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr>
                <td class="table-width-150">{{ item.isn }}</td>
                <td class="table-width-185">{{ item.factoryName }}</td>
                <td class="table-width-185">{{ item.startTime }}</td>
                <td class="table-width-185">{{ item.endTime }}</td>
                <td class="table-width-100">{{ item.code90 }}</td>
                <td class="table-width-125">{{ item.modelName }}</td>
                <td class="table-width-150">{{ item.toolName }}</td>
                <td class="table-width-100">{{ item.toolVer }}</td>
                <td class="table-width-110">{{ item.errorCode }}</td>
                <!-- <td class="table-width-300">
                  <v-btn
                    class="mx-0 mr-3 font-weight-bold small"
                    color="orange"
                    @click="downloadHitTraceLog(item.testResultPk)">
                    <v-icon class="mr-2">mdi-download</v-icon>HITTrace LOG
                  </v-btn>
                  <v-btn
                    class="mx-0 font-weight-bold small"
                    color="orange"
                    @click="downloadNBreport(item.testResultPk)">
                    <v-icon class="mr-2">mdi-download</v-icon>NB Report
                  </v-btn>
                </td> -->
                <td
                  v-for="(col, index) in responseTableShowList"
                  v-show="responseTableShowList[index]"
                  :class="responseColumnClassList[index]+' text-xs-'+responseAlignList[index]"
                  :key="'col'+index"
                >
                  {{ item[index] }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <div
            v-if="pagination.current.rowsPerPage != -1"
            class="text-xs-center pt-2 d-inline-block"
            style="margin-left: 0px;width: calc(100% - 140px);">
            <v-pagination
              v-model="pagination.page"
              :length="pages"/>
          </div>
          <v-autocomplete
            v-if="pagination.current.rowsPerPage != -1"
            v-model="pagination.page"
            :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
            :items="pageslist"
            class="v-text-field__slot d-inline-block float-right mr-0"
            style="width: 90px;"
            persistent-hint
            outlined
          />
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import qs from 'qs'
// import Vue from 'vue'
// import VueC3 from 'vue-c3'
// import 'c3/c3.min.css'
import { mapState } from 'vuex'
import Loading from '@/assets/img/loading.gif'

export default {
  name: 'LcdCalibrationAnalyzer',
  // components: {
  //   VueC3
  // },
  data () {
    return {
      startdate: '2018-04-01',
      highlightedDates: ['2025-02-10', '2025-02-14', '2024-02-20'],
      highlightedEndDates: ['2025-02-08', '2025-02-13', '2024-02-14'],
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      processingView: false,
      // summaryCaseName: '',
      // summaryDate: '',
      // summaryEMS: '',
      // summaryEMSpk: 0,
      // summaryRange: '5',
      // summaryItem: 'CPU_TEMP',
      summaryTableShowList: [],
      // nullDatetime: null,
      // datetime: new Date(),
      // datetimeString: '2019-01-01 12:00',
      // formattedDatetime: '09/01/2019 12:00',
      // textFieldProps: {
      //   appendIcon: 'event'
      // },
      // dateProps: {
      //   headerColor: 'red'
      // },
      // timeProps: {
      //   useSeconds: false,
      //   ampmInTitle: true,
      //   format: '24hr',
      //   allowedMinutes: m => m % 30 === 0
      // },
      shrink_1: true,
      summaryRangeStartDateMenu: false,
      summaryRangeStartDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryRangeEndDateMenu: false,
      summaryRangeEndDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryFactoryMenu: [],
      summaryFactory: '',
      tempFactory: '',
      summaryProjectMenu: [],
      summaryProject: '',
      tempProject: '',
      summaryOHMTypeMenu: [],
      summaryOHMType: '',
      tempOHMType: '',
      tempProdId: '',
      summaryYear: '',
      summaryYearMenu: [],
      summarySeries: '',
      summarySeriesMenu: [],
      tempYear: '',
      tempSeries: '',
      summary: {
        i1Sn: ''
      },
      // RangeAll: true,
      // RangeIndex: 999,
      // RangeMin: 0,
      // RangeMax: 9999,
      // RangeMaxList: {
      //   CPU_TEMP: 200,
      //   GPU_TEMP: 200,
      //   CPU_POWER: 200,
      //   GPU_POWER: 200
      // },
      // OverRangeCount: 0,
      // RangeCount: 1,
      passAmount: '0',
      failAmount: '0',
      totalTestInputs: '0',
      submit: false,
      IsSubmitPage: true,
      isSorting: false,
      responseData: [],
      responseDataOnly: [],
      checkTableInputDefine: [
        { text: 'TP_OHM_TEST_Time1', value: 'tpOhmTestTime1' },
        { text: 'TP_OHM_TEST1', value: 'tpOhmTest1' },
        { text: 'TP_OHM_TEST_Time2', value: 'tpOhmTestTime2' },
        { text: 'TP_OHM_TEST2', value: 'tpOhmTest2' }],
      responseColumnDefine: [
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'ISN',
          value: 'isn'
        },
        {
          align: '',
          class: 'table-width-185',
          fixed: true,
          sortable: true,
          text: 'factoryName',
          value: 'factoryName'
        },
        {
          align: '',
          class: 'table-width-185',
          fixed: true,
          sortable: true,
          text: 'startTime',
          value: 'startTime'
        },
        {
          align: '',
          class: 'table-width-185',
          fixed: true,
          sortable: true,
          text: 'endTime',
          value: 'endTime'
        },
        {
          align: '',
          class: 'table-width-100',
          fixed: true,
          sortable: true,
          text: 'code90',
          value: 'code90'
        },
        {
          align: '',
          class: 'table-width-125',
          fixed: true,
          sortable: true,
          text: 'modelName',
          value: 'modelName'
        },
        {
          align: '',
          class: 'table-width-150',
          fixed: true,
          sortable: true,
          text: 'toolName',
          value: 'toolName'
        },
        {
          align: '',
          class: 'table-width-100',
          fixed: true,
          sortable: true,
          text: 'toolVer',
          value: 'toolVer'
        },
        {
          align: '',
          class: 'table-width-110',
          fixed: true,
          sortable: true,
          text: 'errorCode',
          value: 'errorCode'
        },
        // {
        //   align: '',
        //   class: 'table-width-300',
        //   fixed: true,
        //   sortable: true,
        //   text: '操作',
        //   value: ''
        // },
        {
          align: 'center',
          class: 'table-width-250',
          fixed: false,
          sortable: true,
          text: 'TP_OHM_TEST_Time1',
          value: 'tpOhmTestTime1'
        },
        {
          align: 'center',
          class: 'table-width-200',
          fixed: false,
          sortable: true,
          text: 'TP_OHM_TEST1',
          value: 'tpOhmTest1'
        },
        {
          align: 'center',
          class: 'table-width-250',
          fixed: false,
          sortable: true,
          text: 'TP_OHM_TEST_Time2',
          value: 'tpOhmTestTime2'
        },
        {
          align: 'center',
          class: 'table-width-200',
          fixed: false,
          sortable: true,
          text: 'TP_OHM_TEST2',
          value: 'tpOhmTest2'
        }
      ],
      responseHeaders: [],
      responseHeadersOnly: [],
      responseHeadersList: [],
      responseColumnClassList: {},
      responseAlignList: {},
      responseTableShowList: {},
      responseTableShowListOnly: {},
      responseAreaData: {
        commonFailQty: 0,
        commonFailRate: 0,
        failQty: 0,
        failRate: 0,
        fanErrorCodeList: [],
        fanFailQty: 0,
        fanFailRate: 0,
        noDefineFailQty: 0,
        passQty: 0,
        passRate: 0,
        productionQty: 0,
        thermalFailQty: 0,
        thermalFailRate: 0,
        warningColor: 'green'
      },
      checkList: [],
      checkTableShowList: [],
      // lineXaxisName: [],
      // lineXaxisValue: [],
      rowsAmount: [10, 25, 50, 100],
      pagination: {
        page: 1,
        current: {
          descending: null,
          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          totalItems: 0
        }
      },
      pages: 1,
      isInitialPageLoad: true
      // handler_bar: new Vue()
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    // pages () {
    //   if(this.responseData.length > 0) {
    //     return this.pagination.rowsPerPage ? Math.ceil(this.responseData.length / this.pagination.rowsPerPage) : 10
    //   }
    // },
    pageslist () {
      let i = 0
      const list = []
      if (this.pagination.current.rowsPerPage) {
        for (i = 0; i < Math.ceil(this.pagination.current.totalItems / this.pagination.current.rowsPerPage); i++) {
          list.push(i + 1)
        }
      }
      return list
    }
    // options_bar () {
    //   return {
    //     data: {
    //       x: 'x',
    //       columns: [
    //         this.barXaxisName,
    //         this.barXaxisValue
    //       ],
    //       labels: true,
    //       // labels: {
    //       //   // format: function (v, id, i, j) { return v + '%' }
    //       // },
    //       // onclick: function (d) { alert(d.index) },
    //       onclick: (d) => { this.summaryList(d.index, 'range') },
    //       type: 'bar',
    //       types: {
    //         'NormalDistribution': 'spline'
    //       },
    //       axes: {
    //         'ModelName': 'y'
    //       }
    //       // colors: {
    //       //   ModelName: '#999999'
    //       // }
    //       // onclick: (d, i) => { this.summaryList(d, i) } // {id: "data23", value: 120, ratio: 0.8, index: 1, name: "data23"}
    //       // color: function (color, d) {
    //       //   // d will be 'id' when called for legends
    //       //   return d.value >= 5.0 ? '#ff0000' : d.value >= 3.0 ? '#ff9800' : color
    //       // }
    //       // color: (color, d) => {
    //       //   // d will be 'id' when called for legends
    //       //   return (this.OverRangeCount > 0 && d.index === this.barXaxisName.length - 2) ? '#ffa500' : color
    //       // }
    //     },
    //     axis: {
    //       x: {
    //         type: 'category', // this needed to load string x value
    //         tick: {
    //           rotate: -45,
    //           multiline: false
    //         }
    //         // label: {
    //         //   text: '期',
    //         //   position: 'outer-center'
    //         // }
    //       },
    //       y: {
    //         // max: this.RangeCount,
    //         // min: 0,
    //         // tick: {
    //         //   // count: this.RangeCount + 1
    //         // },
    //         // padding: {
    //         //   top: 0,
    //         //   bottom: 0
    //         // }
    //         // tick: {
    //         //   format: function (value) { return value + '%' }
    //         // }
    //         // label: {
    //         //   text: '%',
    //         //   position: 'outer-middle'
    //         // }
    //       },
    //       y2: {
    //         // show: true
    //         // label: {
    //         //   text: '億',
    //         //   position: 'outer-middle'
    //         // }
    //       }
    //     },
    //     tooltip: {
    //       format: {
    //         title (d) {
    //           // return `第 ${d} 期`
    //         },
    //         value (value, ratio, id) {
    //           // return `${value} 億`
    //         }
    //       }
    //     },
    //     grid: {
    //       x: {
    //         show: true
    //       },
    //       y: {
    //         show: true
    //       }
    //     },
    //     legend: {
    //       position: 'bottom',
    //       padding: 16,
    //       show: false
    //     },
    //     size: {
    //       // width: 640,
    //       height: 500
    //     }
    //   }
    // }
  },
  watch: {
    summaryFactory (val) {
      this.summaryYear = ''
      this.summarySeries = ''
      this.summarySeriesMenus = []
      this.summaryOHMTypeMenu = []
      this.summaryProject = ''
      this.summaryOHMType = ''
      Object.keys(this.summary).forEach(key => {
        this.summary[key] = ''
      })
      // this.summaryProjectMenu = [
      //   { text: 'E1504FA', value: 'E1504FA' },
      //   { text: 'X1403ZA', value: 'X1403ZA' }
      // ]
      // this.summaryOHMTypeMenu = []
      // this.summaryProject = ''
      // this.summaryOHMType = ''
      // Object.keys(this.summary).forEach(key => {
      //   this.summary[key] = ''
      // })
      // if (this.tempProject !== '' && this.isInitialPageLoad) {
      //   this.summaryProject = this.tempProject
      // }
      this.$http.get(`/api/tpohm/getSelectOptionData/year/${val}`).then(res => res.data)
        .then(res => {
          if (res.code === 0) {
            const data = res.data
            this.summaryYearMenu = data
              .filter(item => item !== null && item !== undefined)
              .map(item => ({
                text: item,
                value: item
              }))
            if (this.tempYear !== '' && this.isInitialPageLoad) {
              this.summaryYear = this.tempYear
            }
          }
        })
      const seriesbody = {
        factoryName: this.summaryFactory,
        year: this.summaryYear
      }
      this.$http.get(`/api/tpohm/getSelectOptionData/series?` + qs.stringify(seriesbody)).then(res => res.data)
        .then(res => {
          if (res.code === 0) {
            const data = res.data
            this.summarySeriesMenu = data.filter(item => item !== null && item !== undefined).map(item => ({
              text: item,
              value: item
            }))
            if (this.tempSeries !== '' && this.isInitialPageLoad) {
              this.summarySeries = this.tempSeries
            }
          }
        })
      const body = {
        factoryName: this.summaryFactory,
        year: this.summaryYear,
        series: this.summarySeries
      }
      this.$http.get(`/api/tpohm/getSelectOptionData/model?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.code === 0) {
            const data = res.data
            this.summaryProjectMenu = data.map(item => ({
              text: item.platform ? `${item.modelName}(${item.platform})` : item.modelName,
              value: item.modelName
            }))
            if (this.tempProject !== '' && this.isInitialPageLoad) {
              this.summaryProject = this.tempProject
            }
          }
        })
    },
    summaryYear () {
      this.summarySeries = ''
      this.summaryProjectMenu = []
      this.summaryOHMTypeMenu = []
      this.summaryProject = ''
      this.summaryOHMType = ''
      Object.keys(this.summary).forEach(key => {
        this.summary[key] = ''
      })
      const seriesbody = {
        factoryName: this.summaryFactory,
        year: this.summaryYear
      }
      this.$http.get(`/api/tpohm/getSelectOptionData/series?` + qs.stringify(seriesbody)).then(res => res.data)
        .then(res => {
          if (res.code === 0) {
            const data = res.data
            this.summarySeriesMenu = data.filter(item => item !== null && item !== undefined).map(item => ({
              text: item,
              value: item
            }))
            if (this.tempSeries !== '' && this.isInitialPageLoad) {
              this.summarySeries = this.tempSeries
            }
          }
        })
      const body = {
        factoryName: this.summaryFactory,
        year: this.summaryYear,
        series: this.summarySeries
      }
      this.$http.get(`/api/tpohm/getSelectOptionData/model?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.code === 0) {
            const data = res.data
            this.summaryProjectMenu = data.map(item => ({
              text: item.platform ? `${item.modelName}(${item.platform})` : item.modelName,
              value: item.modelName
            }))
          }
        })
    },
    summarySeries () {
      const body = {
        factoryName: this.summaryFactory,
        year: this.summaryYear,
        series: this.summarySeries
      }
      this.$http.get(`/api/tpohm/getSelectOptionData/model?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.code === 0) {
            const data = res.data
            this.summaryProjectMenu = data.map(item => ({
              text: item.platform ? `${item.modelName}(${item.platform})` : item.modelName,
              value: item.modelName
            }))
            this.summaryOHMTypeMenu = []
            this.summaryProject = ''
            this.summaryOHMType = ''
            Object.keys(this.summary).forEach(key => {
              this.summary[key] = ''
            })
            if (this.tempProject !== '' && this.isInitialPageLoad) {
              this.summaryProject = this.tempProject
            }
          }
        })
    },
    summaryProject (val) {
      // const body = {
      //   factoryPk: this.summaryFactory,
      //   projectPk: val
      // }
      this.summaryOHMTypeMenu = [
        { text: 'TPOHM', value: 'TPOHM' },
        { text: 'DialOHM', value: 'DialOHM' }
      ]
      this.summaryOHMType = ''
      Object.keys(this.summary).forEach(key => {
        this.summary[key] = ''
      })
      if (this.tempOHMType !== '' && this.isInitialPageLoad) {
        this.summaryOHMType = this.tempOHMType
      }
      // this.$http.get(`/api/lcd/analyzeMgmt/getSelectOptionData/OHMType?` + qs.stringify(body)).then(res => res.data)
      //   .then(res => {
      //     if (res.status === 'success') {
      //       this.summaryCalibrationTypeMenu = res.data
      //       this.summaryOHMType = ''
      //       Object.keys(this.summary).forEach(key => {
      //         this.summary[key] = ''
      //       })
      //       if (this.tempOHMType !== '' && this.isInitialPageLoad) {
      //         this.summaryOHMType = this.tempOHMType
      //       }
      //     }
      //   })
    },
    summaryOHMType (val) {
      // Object.keys(this.summary).forEach(key => {
      //   this.summary[key] = ''
      // })
      // this.highlightedDates = ['2025-12-12', '2025-12-13', '2024-12-14']
      // this.highlightedEndDates = ['2025-12-12', '2025-12-13', '2024-12-14']
      // if (this.isInitialPageLoad) {
      //   this.isInitialPageLoad = false
      // }
      const body = {
        factoryName: this.summaryFactory,
        modelName: this.summaryProject,
        OHMType: this.summaryOHMType
      }
      Object.keys(this.summary).forEach(key => {
        this.summary[key] = ''
      })
      this.$http.get(`/api/tpohm/getSelectOptionData/manufacturingDate?` + qs.stringify(body)).then(res => res.data)
        .then(res => {
          if (res.code === 0) {
            this.highlightedDates = res.data
            this.highlightedEndDates = res.data
          }
        })
      if (this.isInitialPageLoad) {
        this.isInitialPageLoad = false
      }
    },
    summaryRangeStartDate (val) {
      this.summaryRangeStartDateMenu = false
      // this.startTimeMenu = true
    },
    // startTime (val) {
    //   if (this.startTimeMenuOperating > 0) {
    //     this.startTimeMenuOperating = 0
    //     this.startTimeMenu = false
    //   } else {
    //     this.startTimeMenuOperating = this.startTimeMenuOperating + 1
    //   }
    // },
    // startTimeMenu (val) {
    //   if (!val) {
    //     this.startTimeMenuOperating = 0
    //   }
    // },
    summaryRangeEndDate (val) {
      this.summaryRangeEndDateMenu = false
      // this.endTimeMenu = true
    },
    // endTime (val) {
    //   if (this.endTimeMenuOperating > 0) {
    //     this.endTimeMenuOperating = 0
    //     this.endTimeMenu = false
    //   } else {
    //     this.endTimeMenuOperating = this.endTimeMenuOperating + 1
    //   }
    // },
    // endTimeMenu (val) {
    //   if (!val) {
    //     this.endTimeMenuOperating = 0
    //   }
    // },
    checkTableShowList (val) {
      this.responseHeaders = JSON.parse(JSON.stringify(this.responseHeadersOnly))
      this.responseTableShowList = JSON.parse(JSON.stringify(this.responseTableShowListOnly))

      this.summaryTableShowList.forEach((s, index) => {
        this.checkTableShowList.forEach((c) => {
          this.responseTableShowList[c] = true
          if (s.value === c) {
            this.responseHeaders.push(this.responseHeadersList[index])
          }
        })
      })
    },
    // responseData (val) {
    //   this.pages = Math.ceil(this.totalRows / this.pagination.rowsPerPage)
    //   if (this.pages > 1) {
    //     setTimeout(() => {
    //       this.pagination.page = this.pages
    //     }, 0)
    //     setTimeout(() => {
    //       this.pagination.page = 1
    //     }, 100)
    //   } else {
    //     setTimeout(() => {
    //       this.pagination.rowsPerPage = 1
    //     }, 0)
    //     setTimeout(() => {
    //       this.pagination.rowsPerPage = this.perPageRows
    //     }, 100)
    //   }
    // },
    // perPageRows (val) {
    //   if (val === -1) {
    //     if (confirm('完整顯示將可能導致效能降低，是否仍完整顯示?')) {
    //       this.pagination.rowsPerPage = val
    //       this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
    //       this.pagination.page = 1
    //     } else {
    //       setTimeout(() => {
    //         this.perPageRows = this.pagination.rowsPerPage
    //       }, 100)
    //     }
    //   } else {
    //     this.pagination.rowsPerPage = val
    //     this.pages = Math.ceil(this.responseData.length / this.pagination.rowsPerPage)
    //     this.pagination.page = 1
    //   }
    // },
    'pagination.current.sortBy' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        // 让排序锁在本次事件循环后释放
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.current.descending' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isSorting = true
        this.$nextTick(() => {
          this.isSorting = false
        })
      }
    },
    'pagination.page': {
      handler (newName, oldName) {
        if (this.isSorting) return
        if (this.submit && !this.IsSubmitPage) {
          this.doTPOHMDataList()
        }
      },
      immediate: true,
      deep: true
    },
    'pagination.current.rowsPerPage': {
      handler (newName, oldName) {
        if (this.isSorting) return
        if (this.submit && !this.IsSubmitPage) {
          this.pagination.page = 1
          this.doTPOHMDataList()
        }
      },
      immediate: true,
      deep: true
    }
    // 'pagination.page' (val) {
    //   this.checkList = []
    // },
    // 'pagination.rowsPerPage' (val) {
    //   this.checkList = []
    // },
    // 'pagination.sortBy' (val) {
    //   this.checkList = []
    // },
    // 'pagination.descending' (val) {
    //   this.checkList = []
    // }
    // summaryDate (val) {
    //   this.summaryDateMenu = false
    // },
    // summaryItem (val) {
    //   this.doSummary()
    // },
    // summaryRange (val) {
    //   this.doSummary()
    // }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/tpohm/TPImpedance')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          JSON.parse(localStorage.getItem('moduleDataInitDate')).forEach((n) => {
            if (n.name === 'tpohm') {
              this.startdate = n.value
            }
          })
          if (this.$route.params.rangeStartDate && this.$route.params.rangeEndDate && this.$route.params.factory && this.$route.params.project && this.$route.params.OHMType && this.$route.params.prodId && !this.isPageReload()) {
            this.summaryRangeStartDate = this.$route.params.rangeStartDate
            this.summaryRangeEndDate = this.$route.params.rangeEndDate
            this.tempFactory = Number(this.$route.params.factory)
            this.tempProject = Number(this.$route.params.project)
            this.tempSeries = this.$route.params.Series
            this.tempYear = this.$route.params.Year
            this.tempOHMType = this.$route.params.OHMType
            this.tempProdId = this.$route.params.prodId
          }
          // this.summaryFactoryMenu = [
          //   { text: 'PEGA_CQ', value: 'tpohm' },
          //   { text: 'QUANTA_CQ', value: 'dialohm' },
          //   { text: 'IEC', value: 'IEC' }
          // ]
          // if (this.tempFactory !== '') {
          //   this.summaryFactory = this.tempFactory
          // }
          this.$http.get('/api/tpohm/getSelectOptionData/factoryName').then(res => res.data)
            .then(res => {
              if (res.code === 0) {
                const data = res.data
                this.summaryFactoryMenu = data.map(item => ({
                  text: item,
                  value: item
                }))
                if (this.tempFactory !== '') {
                  this.summaryFactory = this.tempFactory
                }
              }
            })
          this.doResponseColumnDefine()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    isPageReload () {
      if (performance.getEntriesByType && performance.getEntriesByType('navigation').length > 0) {
        return performance.getEntriesByType('navigation')[0].type === 'reload'
      } else if (performance.navigation) {
        return performance.navigation.type === 1
      }
      return false
    },
    getEventColor (date) {
      return this.highlightedDates.includes(date) ? 'green' : ''// 蓝色小圆点
    },
    getEndEventColor (date) {
      return this.highlightedEndDates.includes(date) ? 'green' : ''// 蓝色小圆点
    },
    doResponseColumnDefine () {
      // this.responseHeaders.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      // this.responseHeadersOnly.push({
      //   align: '',
      //   class: 'table-width-55',
      //   fixed: true,
      //   sortable: false,
      //   text: '標記',
      //   value: ''
      // })
      this.responseHeadersList = []
      this.responseHeaders = []
      this.responseHeadersOnly = []
      this.responseTableShowList = {}
      this.responseTableShowListOnly = {}
      this.responseColumnClassList = {}
      this.responseAlignList = {}
      this.summaryTableShowList = []
      this.responseColumnDefine.forEach((r) => {
        if (r.fixed) {
          this.responseHeaders.push(r)
          this.responseHeadersOnly.push(r)
        } else {
          this.responseHeadersList.push(r)
          this.responseTableShowList[r.value] = r.fixed
          this.responseTableShowListOnly[r.value] = r.fixed
          this.responseColumnClassList[r.value] = r.class
          this.responseAlignList[r.value] = r.align
          this.summaryTableShowList.push({ text: r.text, value: r.value })
        }
      })
    },
    // doBeforeLink (TtrsPk, deviceSn) {
    //   this.$http.post('/api/thermal/getSingleDeviceBurnInDataStatistic?ttrsPk=' + TtrsPk).then(res => res.data)
    //     .then(res => {
    //       if (res.status === 'success') {
    //         let Groups = res.data.fanTestData.length
    //         const routeData = this.$router.resolve({ path: '/thermal/singleDeviceBurnInDataStatistic/' + TtrsPk + '/' + Groups, query: { sn: deviceSn, modelname: this.summaryCaseName, date: this.summaryDate, ems: this.summaryEMS } })
    //         window.open(routeData.href, '_blank')
    //       }
    //     })
    // },
    // doSummary (type) {
    //   this.barXaxisName = ['x']
    //   this.barXaxisValue = ['ModelName']
    //   let AllArray = []
    //   this.responseDataOnly.forEach((r) => {
    //     if (r[this.summaryItem] >= 0) {
    //       AllArray.push(r[this.summaryItem])
    //     }
    //   })
    //   this.RangeMax = Math.ceil(Math.max(...AllArray) / this.summaryRange) * this.summaryRange
    //   this.RangeMin = Math.floor(Math.min(...AllArray) / this.summaryRange) * this.summaryRange
    //   if (this.RangeMax > this.RangeMaxList[this.summaryItem]) {
    //     this.RangeMax = Math.min(this.RangeMax, this.RangeMaxList[this.summaryItem])
    //   }
    //   this.OverRangeCount = 0
    //   const RangeArray = []
    //   for (let i = this.RangeMin; i < this.RangeMax; i = i + this.summaryRange) {
    //     RangeArray[(i - this.RangeMin) / this.summaryRange] = 0
    //   }
    //   AllArray.forEach((r) => {
    //     if (r > this.RangeMaxList[this.summaryItem]) {
    //       this.OverRangeCount = this.OverRangeCount + 1
    //     } else {
    //       if (RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] > 0) {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] + 1
    //       } else {
    //         RangeArray[Math.floor((r - this.RangeMin) / this.summaryRange)] = 1
    //       }
    //     }
    //   })

    //   this.RangeCount = Math.max(...RangeArray)
    //   for (let i = 0; i < RangeArray.length; i++) {
    //     this.barXaxisValue.push(RangeArray[i] || 0)
    //     switch (true) {
    //       case (this.summaryRange === '5' || this.summaryRange === '10'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(0) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(0))
    //         break
    //       case (this.summaryRange === '2.5' || this.summaryRange === '7.5'):
    //         this.barXaxisName.push((this.RangeMin + (i * this.summaryRange)).toFixed(1) + '-' + (this.RangeMin + ((i + 1) * this.summaryRange)).toFixed(1))
    //         break
    //       // default:
    //       // return
    //     }
    //   }
    //   if (this.OverRangeCount > 0) {
    //     this.barXaxisValue.push(this.OverRangeCount)
    //     this.barXaxisName.push('>' + this.RangeMaxList[this.summaryItem])
    //   }
    //   // RangeArray.forEach((r, index) => {
    //   //   console.log(r)
    //   //   console.log(index)
    //   //   this.barXaxisValue.push(r)
    //   //   this.barXaxisName.push((this.RangeMin + (index * this.summaryRange)) + '-' + (this.RangeMin + ((index + 1) * this.summaryRange)))
    //   // })
    //   if (type === 'init') {
    //     this.handler_bar.$emit('init', this.options_bar)
    //   } else {
    //     this.handler_bar.$emit('dispatch', chart => {
    //       const options = {
    //         columns: [
    //           this.barXaxisName,
    //           this.barXaxisValue
    //         ]
    //       }
    //       chart.load(options)
    //     })
    //   }
    // },
    checkTableShowListAll () {
      this.checkTableShowList = []
      this.summaryTableShowList.forEach((s) => {
        this.checkTableShowList.push(s.value)
      })
    },
    checkTableShowListClear () {
      this.checkTableShowList = []
    },
    doSubmit () {
      if (this.doSubmitVerification()) {
        this.loadingView = true
        this.pagination.page = 1
        this.pagination.current.rowsPerPage = 25
        this.doTPOHMDataList()
        this.doTPOHMSummaryInfo()
        this.doTPOHMSaveFilterInfo()
        // setTimeout(() => {
        //   this.loadingView = false
        // }, 0)
        const Url = '/tpohm/TPImpedance/' + this.summaryFactory + '/' + this.summaryProject + '/' + this.summaryOHMType + '/' + this.summaryRangeStartDate + '/' + this.summaryRangeEndDate
        if (this.$router.history.current.path !== Url) {
          this.$router.replace(Url)
        }
        // Object.keys(this.summary).forEach(key => {
        //   this.summary[key] = ''
        // })
      }
    },
    doSubmitVerification () {
      if (this.summaryFactory === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Factory'
        return false
      } else if (this.summaryProject === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Project'
        return false
      } else if (this.summaryOHMType === '') {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '請選擇Type'
        return false
      } if ((new Date(this.summaryRangeEndDate).getTime() < new Date(this.summaryRangeStartDate).getTime())) {
        this.snackbar = true
        this.snackbarColor = 'red'
        this.snackbarMsg = '結尾時間不得早於起始時間'
        return false
      } else {
        return true
      }
    },
    doTPOHMSaveFilterInfo () {
      const body = {
        page: this.pagination.page,
        size: this.pagination.current.rowsPerPage,
        sort: (this.pagination.current.descending !== null) ? this.pagination.current.sortBy : '0',
        // sortType: this.pagination.current.descending ? 'DESC' : ((this.pagination.current.descending !== null) ? 'ASC' : ''),
        factoryName: this.summaryFactory,
        modelName: this.summaryProject,
        ohmType: this.summaryOHMType,
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate,
        isn: this.summary.i1Sn,
        errorCode: ''
      }
      localStorage.setItem('tpohmFilterInfo', JSON.stringify(body))
      // localStorage.setItem('lcdFilterUpdateTime', this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
    },
    doTPOHMSummaryInfo () {
      // this.passAmount = String(2)
      // this.failAmount = String(1)
      // this.totalTestInputs = String(3)
      // this.loadingView = false
      const body = {
        page: this.pagination.page,
        size: this.pagination.current.rowsPerPage,
        sort: (this.pagination.current.descending !== null) ? this.pagination.current.sortBy : '0',
        // sortType: this.pagination.current.descending ? 'DESC' : ((this.pagination.current.descending !== null) ? 'ASC' : ''),
        factoryName: this.summaryFactory,
        modelName: this.summaryProject,
        ohmType: this.summaryOHMType,
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate,
        isn: this.summary.i1Sn,
        errorCode: ''
      }
      this.$http.post('/api/tpohm/calibrationSummaryInfo', body).then(res => res.data)
        .then(res => {
          if (res.code === 0) {
            this.passAmount = String(res.data.passAmount)
            this.failAmount = String(res.data.failAmount)
            this.totalTestInputs = String(res.data.totalTestInputs)
            this.loadingView = false
          }
        })
    },
    doTPOHMDataList () {
      this.submit = true
      // var pagingList = [
      //   {
      //     isn: 'ISN12345678',
      //     factoryname: 'PEGA_CQ',
      //     StartTime: '2025-01-10 09:32:11',
      //     EndTime: '2025-01-10 09:35:28',
      //     code90: 'PASS',
      //     modelname: 'ROG_2025_V1',
      //     ToolName: 'LCD_Calibration_Tool',
      //     ToolVer: 'v3.2.1',
      //     ErrorCode: '',
      //     TP_OHM_TEST_Time1: '2.35s',
      //     TP_OHM_TEST1: 152.3,
      //     TP_OHM_TEST_Time2: '2.48s',
      //     TP_OHM_TEST2: 149.8
      //   },
      //   {
      //     isn: 'ISN98765432',
      //     factoryname: 'PEGA_CQ',
      //     StartTime: '2025-01-11 14:21:05',
      //     EndTime: '2025-01-11 14:23:49',
      //     code90: 'FAIL',
      //     modelname: 'ROG_2025_V2',
      //     ToolName: 'LCD_Calibration_Tool',
      //     ToolVer: 'v3.2.1',
      //     ErrorCode: 'E1234',
      //     TP_OHM_TEST_Time1: '2.40s',
      //     TP_OHM_TEST1: 163.2,
      //     TP_OHM_TEST_Time2: '2.52s',
      //     TP_OHM_TEST2: 160.5
      //   }
      // ]
      // this.responseData = pagingList
      // this.responseDataOnly = pagingList

      // this.checkTableShowListClear()
      // this.doResponseColumnDefine()
      // this.pagination.current.totalItems = Number(26)
      // this.IsSubmitPage = true
      // this.pages = Number(Math.ceil(26 / this.pagination.current.rowsPerPage))
      // this.IsSubmitPage = false
      const body = {
        page: this.pagination.page,
        size: this.pagination.current.rowsPerPage,
        sort: (this.pagination.current.descending !== null) ? this.pagination.current.sortBy : '0',
        // sortType: this.pagination.current.descending ? 'DESC' : ((this.pagination.current.descending !== null) ? 'ASC' : ''),
        factoryName: this.summaryFactory,
        modelName: this.summaryProject,
        ohmType: this.summaryOHMType,
        startTime: this.summaryRangeStartDate,
        endTime: this.summaryRangeEndDate,
        isn: this.summary.i1Sn,
        errorCode: ''
      }
      this.$http.post('/api/tpohm/lcdCalibrationDataList', body).then(res => res.data)
        .then(res => {
          if (res.code === 0) {
            this.pagination.current.rowsPerPage = res.data.pageSize
            this.responseData = res.data.data
            this.responseDataOnly = res.data.data

            this.checkTableShowListClear()
            this.doResponseColumnDefine()
            this.pagination.current.totalItems = Number(res.data.totalRecords)
            this.IsSubmitPage = true
          }
          return res
        })
        .then(res => {
          if (res.code === 0) {
            this.pages = res.data.totalPages
            this.IsSubmitPage = false
          }
        })
    },

    downloadCSV () {
      if (this.doSubmitVerification()) {
        this.processingView = true
        const body = {
          page: this.pagination.page,
          size: this.pagination.current.rowsPerPage,
          sort: (this.pagination.current.descending !== null) ? this.pagination.current.sortBy : '0',
          // sortType: this.pagination.current.descending ? 'DESC' : ((this.pagination.current.descending !== null) ? 'ASC' : ''),
          factoryName: this.summaryFactory,
          modelName: this.summaryProject,
          ohmType: this.summaryOHMType,
          startTime: this.summaryRangeStartDate,
          endTime: this.summaryRangeEndDate,
          isn: this.summary.i1Sn,
          errorCode: ''
        }
        this.$http.post('/api/tpohm/excel/exportTpohmExcel', body, { responseType: 'blob' })
          .then(res => {
            this.processingView = false

            // 统一处理Blob数据：先尝试解析为JSON（业务提示），失败则执行Excel下载
            const blob = res.data // res.data已是Blob对象，直接使用
            const reader = new FileReader()

            reader.onload = () => {
              try {
                // 尝试将Blob读取为文本并解析为JSON（处理业务提示）
                const jsonData = JSON.parse(reader.result)
                // 解析成功：按原有业务逻辑处理
                if (jsonData.status === 'success') {
                  alert(jsonData.data)
                } else {
                  this.snackbar = true
                  this.snackbarColor = 'red'
                  this.snackbarMsg = jsonData.errMsg + ' (' + jsonData.errCode + ')'
                }
              } catch (e) {
                // 解析失败：正常Excel流，执行下载（无content-disposition也能正常下载）
                // 生成TPOHM+当前日期时分秒的自定义文件名
                const now = new Date()
                const year = now.getFullYear()
                const month = (now.getMonth() + 1).toString().padStart(2, '0')
                const day = now.getDate().toString().padStart(2, '0')
                const hours = now.getHours().toString().padStart(2, '0')
                const minutes = now.getMinutes().toString().padStart(2, '0')
                const seconds = now.getSeconds().toString().padStart(2, '0')
                // 拼接文件名：TPOHM_20251223_165030.xlsx
                const customFileName = `TPOHM_${year}${month}${day}_${hours}${minutes}${seconds}.xlsx`

                // 创建下载链接
                const url = window.URL.createObjectURL(blob)
                const downloadLink = document.createElement('a')
                downloadLink.href = url
                downloadLink.download = customFileName // 直接使用自定义文件名

                // 执行下载
                document.body.appendChild(downloadLink)
                downloadLink.click()

                // 清理资源：避免内存泄漏和DOM冗余
                document.body.removeChild(downloadLink)
                window.URL.revokeObjectURL(url)

                // 下载成功提示（可选，可根据需求开启/关闭）
                this.snackbar = true
                this.snackbarColor = 'green'
                this.snackbarMsg = 'Excel文件下載成功'
              }
            }

            // 文件读取失败的异常处理
            reader.onerror = () => {
              this.processingView = false
              this.snackbar = true
              this.snackbarColor = 'red'
              this.snackbarMsg = '解析返回數據失敗，請通知系統管理員'
            }

            // 以文本格式读取Blob，用于区分业务提示和Excel流
            reader.readAsText(blob)
          })
          .catch(err => {
            this.processingView = false
            this.snackbar = true
            this.snackbarColor = 'orange'
            this.snackbarMsg = err
          })
      }
    }
  }
}
</script>
<style>
/* .c3-axis-x .tick tspan:hover {
  cursor: pointer;
} */

.text-center {
  text-align: center !important;
}
</style>
